import React from 'react';

/**
 * @typedef {{ doConnect: () => Promise<void>, doDisconnect: () => void, connected: boolean, authPromise: Promise<void> }} ExtendedSocket
 * @type {React.Context<ExtendedSocket & import('socket.io-client').Socket>}
 */

export const SocketContext = React.createContext(null);
